import { JsonProperty, JsonObject } from 'json2typescript';

import { Required, EmptyControl } from '@hvlng/framework-bff/core';

@JsonObject('KovanHrObjectCardDetailModel')
export class ObjectCardDetailModel  {
    @EmptyControl()
    @JsonProperty('fieldName', String, true)
    fieldName: string = null;

    @EmptyControl()
    @JsonProperty('recordCount', Number, true)
    recordCount: string = null;

}
